var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.goDefined)?_c('div',{staticClass:"card text-white text-center",class:_vm.backgroundColor},[_c('div',{staticClass:"card-body"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }